import React, { useState, useEffect } from "react";
import Header from "../../../components/layout/header";
import FastNavigator from "../../../components/layout/footer"; // Import FastNavigator

import "./Hero.scss";

// 📌 Import Images
import truck from "../../../images/truck.jpg";
import port1 from "../../../images/port1.jpg";
import port2 from "../../../images/port2.jpg";

const images = [
  { src: truck, heading: "Reliable Transport Solutions" },
  { src: port1, heading: "Global Shipping Excellence" },
  { src: port2, heading: "Seamless Port Operations" },
];

const defaultHeading = "Thinking Ahead - Moving Forward";

const Hero = () => {
  const [currentImage, setCurrentImage] = useState(0);
  const [hoveredImage, setHoveredImage] = useState(null);
  const [heading, setHeading] = useState(defaultHeading);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prevImage) => (prevImage + 1) % images.length);
      setHeading(defaultHeading); // Reset heading when image changes
    }, 7000); // 7 seconds

    return () => clearInterval(interval);
  }, []);

  // Set background image and heading based on hover or slider
  const backgroundImage = hoveredImage
    ? hoveredImage.src
    : images[currentImage].src;
  const currentHeading = hoveredImage ? hoveredImage.heading : heading;

  return (
    <div className="Main">
      <Header />

      <div
        className="slider-container"
        style={{ backgroundImage: `url(${backgroundImage})` }}
      >
        <h1>{currentHeading}</h1>
      </div>

      {/* Pass setHoveredImage to FastNavigator */}
      <FastNavigator setHoveredImage={setHoveredImage} />
    </div>
  );
};

export default Hero;
